(function() {
	'use strict';
	var $ = avm.require('cash');


	if ( $(".slider-sliderTestimLeft").length > 0 ) {

		var sliderTestimLeft = tns({
			"container": ".slider-sliderTestimLeft",
			"controlsContainer": ".slider-sliderTestimLeft-controls",
			"preventScrollOnTouch": "force",
			"controlsPosition": "bottom",
			"controls": false,
			"navPosition": "bottom",
			"mouseDrag": true,
			"speed": 400,
			"fixedWidth": 344,
			"center": true,
			"loop": false,
			"responsive": {
				"768": {
					"fixedWidth": 532
				},
				"992": {
					"controls": true,
					"fixedWidth":644
				},
				"1280": {
					"fixedWidth": 816
				},
				"1366": {
					"fixedWidth": 864
				},
				"1600": {
					"fixedWidth": 928
				}
			}
		});

	}
})();
